// Geanimeerd CP-beeldmerk, nagebouwd uit de officiële animatiebestanden
// (CP_logo_anima_01.ai): de stam groeit, de blaadjes ontvouwen en de C en de
// boog van de P draaien erin. Eén kleur, zoals het echte logo.
// Gebruik: <CpLogoAnimatie kleur="#045E51" style={{ width: 80 }} herhaal={60000} />
import React from "react";

const STAM =
  "M1026.2 473.2H898.5c-2.7 0-4.9 2.2-4.9 4.9 0 0-.1 835.2-.2 839-.6 24.4-3.3 84.1-14.7 123.1-.9 3.1 1.5 6.2 4.7 6.2h152.9c3.2 0 5.6-3.1 4.7-6.2-10.5-35.7-13.6-88.8-14.5-116.2-.2-8.3-.3-16-.4-22.9v-67.8h0Z";
const BOOG_P =
  "M1110.8 473.2h-84.6l.04 137.5c0-2.7 2.2-4.9 4.9-4.9h79.6c161.2 0 292.3 129.6 292.4 288.9 0 77.2-30 149.8-84.6 204.5-43 43-96.6 70.7-155.7 80.6-2.3.4-4.1 2.4-4.1 4.8v123.9c0 2.9 2.6 5.2 5.5 4.9 93.5-11.1 181.1-53.4 248.1-120.5 79.6-79.7 123.5-185.6 123.4-298.2-.1-232.3-190.8-421.4-425-421.4Z";
const BOOG_C =
  "M757 1179.6c-138-23.4-240.3-143.3-240.3-284.8S619 633.4 757 609.9c2.3-.4 4.1-2.4 4.1-4.8V481.2c0-2.9-2.6-5.2-5.5-4.9-99.1 11.8-190.7 58.3-259.2 132.3-72.4 78.2-112.3 179.8-112.3 286.2s39.9 208 112.3 286.2c68.4 73.9 159.9 120.4 259.2 132.3 2.9.3 5.5-2 5.5-4.9v-124c0-2.4-1.7-4.4-4.1-4.8Z";
const BLAD_R =
  "M1026.2 1094.7c0-.2 0-.3 0-.5.2-104.2 46.5-143.1 157.6-143.1h19.1c2.3 0 4.3-1.6 4.8-3.9l39.3-142.1c.6-3-1.7-5.9-4.8-5.9h-48.3c-83.4 0-129.4 46.7-157.7 160.9-.6 2.3-2.6 3.8-5 3.7h-.4c-2.6-.1-4.5-2.2-4.6-4.8v0h0Z";
const BLAD_L =
  "M893.6 1095.1c0-.2 0-.3 0-.5-.2-104.2-46.5-143.1-157.6-143.1h-19.1c-2.3 0-4.3-1.6-4.8-3.9l-39.3-142.1c-.6-3 1.7-5.9 4.8-5.9h48.3c83.4 0 129.4 46.7 157.7 160.9.6 2.3 2.6 3.8 5 3.7h.4c2.6-.1 4.5-2.2 4.6-4.8v0h0Z";

const CSS = `
@keyframes cpStam { from { transform: scaleY(0); } to { transform: scaleY(1); } }
@keyframes cpBladL { from { transform: rotate(35deg) scale(0); } to { transform: none; } }
@keyframes cpBladR { from { transform: rotate(-35deg) scale(0); } to { transform: none; } }
@keyframes cpBoogC { from { transform: rotate(-100deg); opacity: 0; } to { transform: none; opacity: 1; } }
@keyframes cpBoogP { from { transform: rotate(100deg); opacity: 0; } to { transform: none; opacity: 1; } }
.cp-la path { transform-box: fill-box; animation-fill-mode: both; animation-timing-function: cubic-bezier(.2,.8,.2,1); }
.cp-la .cp-la-stam { transform-origin: 50% 100%; animation-name: cpStam; animation-duration: .7s; }
.cp-la .cp-la-bl { transform-origin: 100% 100%; animation-name: cpBladL; animation-duration: .6s; animation-delay: .5s; }
.cp-la .cp-la-br { transform-origin: 0% 100%; animation-name: cpBladR; animation-duration: .6s; animation-delay: .5s; }
.cp-la .cp-la-c, .cp-la .cp-la-p { transform-box: view-box; transform-origin: 960px 895px; animation-duration: .9s; animation-delay: .75s; }
.cp-la .cp-la-c { animation-name: cpBoogC; }
.cp-la .cp-la-p { animation-name: cpBoogP; }
@media (prefers-reduced-motion: reduce) { .cp-la path { animation: none !important; } }
`;
let cssGeplaatst = false;
const plaatsCss = () => {
  if (cssGeplaatst || typeof document === "undefined") return;
  const el = document.createElement("style");
  el.textContent = CSS;
  document.head.appendChild(el);
  cssGeplaatst = true;
};

export const CpLogoAnimatie = ({ kleur = "currentColor", herhaal = 0, style, className, title = "Center Parcs" }) => {
  plaatsCss();
  const [ronde, setRonde] = React.useState(0);
  React.useEffect(() => {
    if (!herhaal) return undefined;
    const t = setInterval(() => setRonde((r) => r + 1), herhaal);
    return () => clearInterval(t);
  }, [herhaal]);
  return (
    <svg
      key={ronde}
      viewBox="370 460 1180 1000"
      className={`cp-la ${className || ""}`}
      style={{ display: "block", fill: kleur, overflow: "visible", ...style }}
      role="img"
      aria-label={title}
    >
      <path className="cp-la-c" d={BOOG_C} />
      <path className="cp-la-p" d={BOOG_P} />
      <path className="cp-la-stam" d={STAM} />
      <path className="cp-la-bl" d={BLAD_L} />
      <path className="cp-la-br" d={BLAD_R} />
    </svg>
  );
};

export default CpLogoAnimatie;
